<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row">
                <div class="col-md-9">
                    <nav class="nav nav-tabs mb-3">
                        <a class="nav-link ml-1 active" data-toggle="tab" @click="setCurrentTab('fizical-card')" href="#fizical-card">کارت هدیه فیزیکی آماده</a>
                        <a class="nav-link" data-toggle="tab" @click="setCurrentTab('fizical-fizical-card')" href="#fizical-fizical-card">کارت هدیه فیزیکی دلخواه</a>
                    </nav>
                    <div class="tab-content">
                        <div class="tab-pane active show" id="fizical-card">
                            <FizicalCard v-if="currentTab == 'fizical-card'" :addToCard="addToCard" :depositsList="depositsList" />
                        </div>
                        <div class="tab-pane" id="fizical-fizical-card">
                            <CustomCard v-if="currentTab == 'fizical-fizical-card'" :addToCard="addToCard" :depositsList="depositsList" />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card custom-card card-body tx-white-8 bg-gray-800">
                        <h6>سبد خرید</h6>
                        <hr class="mb-4 mt-2">
                        <p v-if="!basket.length" class="text-center mb-0">سبد خرید خالی است</p>
                        <div v-else>
                            <div class="row mb-3" v-for="(card,index) in basket" :key="index">
                                <div class="col-md-4 pl-0">
                                    <img :src="!card.imageUrl.includes('base64') ? ('https://cardapi.sabinarya.com' + card.imageUrl) : card.imageUrl" class="w-100">
                                </div>
                                <div class="col-md-5">
                                    <p class="mb-1">{{ card.title }}</p>
                                    <p class="mb-1">تعداد: {{ card.itemsCount }}</p>
                                    <p class="mb-1">مبلغ شارژ: {{ card.deposit ? new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(card.deposit) : 0 }}</p>
                                </div>
                                <div class="col-md-3">
                                    <button class="btn ripple btn-danger btn-icon float-left" @click="removeCard(index)"><i class="fe fe-minus"></i></button>
                                </div>
                            </div>
                            <hr class="mt-2 mb-4">
                            <p>مجموع قیمت جسم کارت ها : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(cardsPrice) }} ریال</p>
                            <p>مجموع قیمت شارژ کارت ها : {{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(chargesPrice) }} ریال</p>
                            <button class="btn btn-success btn-block" @click="submit">تایید و ثبت سفارش</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FizicalCard from './Cards/FizicalCard';
import CustomCard from './Cards/CustomCard';
export default {
    name: 'Create',
    components: {FizicalCard,CustomCard},
    data(){
        return {
            nationalCode: '',
            maxLength: 10,
            customerDetails: {},
            legalCustomerDetails: {},
            customerId: 0,
            basket: [],
            currentTab: 'fizical-card',
            discount: 0,
            depositsList: [],
            cardsPrice: 0,
            chargesPrice: 0,
            totalPrice: 0,
            displayedTotalPrice: 0,
            showLoading: false
        }
    },
    watch: {
        discount: function(value){
            let discount = parseInt(value.toString().replace(/,/g,''));
            if(!this.discount)
                this.discount = 0;
            else if(this.totalPrice > discount)
                this.displayedTotalPrice = this.totalPrice - discount;
            else{
                this.discount = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(this.totalPrice);
                this.displayedTotalPrice = 0;
            }
        }
    },
    methods: {
        getData(){
            this.$api.get('Cards/Deposits').then(({data}) => {
                this.showLoading = false;
                if(data.status){
                    let deposits = data.result;
                    deposits.sort((a,b) => {
                        return a.depositValue - b.depositValue;
                    })
                    this.depositsList = deposits;
                }
            });
        },
        setCurrentTab(tab){
            this.currentTab = tab;
        },
        addToCard(themeId,title,cardType,itemsCount,price,imageUrl,depositId,optionalCredit = null,metaData = []){
            depositId = parseInt(depositId);
            let deposit = 0;
            if(depositId == 61 && optionalCredit){
                optionalCredit = parseInt(optionalCredit.replace(/,/g,''));
                deposit = optionalCredit;
            }else{
                let getDeposit = this.depositsList.filter(deposit => deposit.depositId == depositId)[0];
                if(getDeposit && depositId != 41)
                    deposit = getDeposit.depositValue;
                else
                    deposit = 0;
            }
            if(cardType == 1 || cardType == 2){
                let hasInBasket = this.basket.filter(item => item.themeId == themeId && item.cardType == cardType && item.depositId == depositId && (item.optionalCredit == optionalCredit || item.optionalCredit == 0));
                if(hasInBasket.length){
                    let findIndex = this.basket.findIndex(item => item == hasInBasket[0]);
                    this.basket[findIndex].itemsCount = parseInt(this.basket[findIndex].itemsCount) + parseInt(itemsCount);
                }
                else
                    this.basket.push({
                        themeId,
                        title: cardType == 1 ? title : (cardType == 2 ? (title + ' مجازی') : (cardType == 3 ? 'کارت هدیه مجازی' : 'کارت هدیه دلخواه')),
                        imageUrl,
                        itemsCount: parseInt(itemsCount),
                        price,
                        cardType,
                        depositId,
                        optionalCredit: depositId == 61 ? optionalCredit : 0,
                        deposit,
                        metaDatas: metaData
                    });
            }else
                this.basket.push({
                    themeId,
                    title: cardType == 1 ? title : (cardType == 2 ? (title + ' مجازی') : (cardType == 3 ? 'کارت هدیه دلخواه' : 'کارت هدیه مجازی')),
                    imageUrl,
                    itemsCount: parseInt(itemsCount),
                    price,
                    cardType,
                    depositId,
                    optionalCredit: depositId == 61 ? optionalCredit : 0,
                    deposit,
                    metaDatas: metaData
                });
            this.calcTotalPrice();
        },
        calcTotalPrice(){
            let totalPrice = 0;
            let depositAmount = 0;
            this.chargesPrice = 0;
            this.cardsPrice = 0;
            let getDeposit;
            this.basket.map(item => {
                depositAmount = 0;
                if(item.depositId && item.depositId != 41){
                    if(item.depositId == 61)
                        depositAmount += (parseInt(item.optionalCredit) * item.itemsCount);
                    else{
                        getDeposit = this.depositsList.filter(deposit => deposit.depositId == item.depositId)[0];
                        depositAmount += (parseInt(getDeposit.depositValue) * item.itemsCount);
                    }
                }
                this.cardsPrice += (item.price * item.itemsCount);
                this.chargesPrice += depositAmount;
                totalPrice += (item.price * item.itemsCount) + depositAmount;
            });
            this.totalPrice = totalPrice;
            let discount = parseInt(this.discount.toString().replace(/,/g,''));
            if(totalPrice > discount)                
                this.displayedTotalPrice = totalPrice - discount;
            else
                this.displayedTotalPrice = 0;
        },
        searchCustomer(){
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status){
                    this.legalCustomerDetails = data.result;
                    this.setCurrentTab('fizical-card');
                }
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        removeCard(itemIndex){
            let basket = this.basket.filter((item,index) => index != itemIndex);
            this.basket = basket;
            this.calcTotalPrice();
        },
        discountNumberFormat(){
            let value = this.discount.toString().replace(/,/g,'');
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.discount = value;
        },
        changeCustomerType(){
            this.customerDetails = {};
            this.legalCustomerDetails = {};
            this.maxLength = this.customerType == 1 ? 10 : 11;
            this.nationalCode = '';
        },
        submit(){
            this.$swal({
                icon: 'warning',
                title: 'توجه !',
                text: 'آیا از ثبت سفارش اطمینان دارید ؟',
                confirmButtonText: 'ثبت سفارش',
                showCancelButton: true,
                cancelButtonText: 'لغو'
            }).then((result) => {
                if(result.isConfirmed){
                    this.showLoading = true;
                    const postedData = {
                        items: this.basket,
                        isAdmin: false
                    };
                    this.$api.post('Organizations/Orders',postedData).then(({data}) => {
                        if(data.status)
                            this.$swal({
                                icon: 'success',
                                title: 'تبریک !',
                                text: 'ثبت سفارش با موفقیت انجام شد',
                            }).then(res => {
                                if(res.isConfirmed){
                                    this.$router.push({name: 'organization.show',params: {id: data.result.orderId}});
                                }
                            });
                    }).catch(({response}) => {
                        let html = '';
                        response.data.errors.map(err => html += err.message + '<br>');
                        this.$swal({
                            icon: 'error',
                            title: 'خطا !',
                            html
                        });
                    }).finally(() => {
                        this.showLoading = false;
                    });
                }else
                    this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>
